export enum ERoles {
  admin = 'admin',
  annotator = 'annotator',
  campaign = 'campaign',
  system = 'system',
  campaignSub = 'campaign_sub',
  creator = 'creator',
  support = 'support',
}
